import { BiDashboardSummary } from '@euler/model/bi/dashboard';

/**
 * A staff dashboard: 我的看板 about a colleague, which a manager holds —
 * its subject is not its owner. One's own 我的看板 is about its owner.
 */
export function biIsStaffDashboard(
  item: Pick<BiDashboardSummary, 'subjectMemberId' | 'ownerMemberId'>,
): boolean {
  return (
    item.subjectMemberId !== null && item.subjectMemberId !== item.ownerMemberId
  );
}
